export const createSession = (duration: number, unit: 'hours' | 'minutes') => {
  let seconds = 0;

  if (unit === 'hours') {
    seconds = duration * 3600;
  } else if (unit === 'minutes') {
    seconds = duration * 60;
  }

  const session = { expiresAt: seconds };
  localStorage.setItem('session', JSON.stringify(session));
};

export const getSession = (): string | null => {
  const sessionString = localStorage.getItem('session');
  return sessionString;
};

export const clearSession = (): void => {
  localStorage.removeItem('session');
};

export const clearCurrentSession = () => {
  localStorage.removeItem('auth_type');
  localStorage.removeItem('activityOnLoad');
  localStorage.removeItem('inactivity');
  localStorage.removeItem('inbox');
  localStorage.removeItem('exemptSwitchProfileDeny');
  localStorage.removeItem('entityChanged');
  // IPS implementation for clearing local storage variables for cart
  localStorage.removeItem('page_index');
  localStorage.removeItem('selected_item');
  localStorage.removeItem('selected_api_item');
  localStorage.removeItem('cart_origin');
  localStorage.removeItem('account_info');
  localStorage.removeItem('delivery_data');
  clearSession();
};

export const saveAuthType = (type: string) => {
  localStorage.setItem('auth_type', type);
};

export const onLoadActivity = () => {
  localStorage.setItem('activityOnLoad', 'true');
};

export const getOnLoadActivity = () => {
  return localStorage.getItem('activityOnLoad');
};

export const removeOnLoadActivity = () => {
  return localStorage.removeItem('activityOnLoad');
};

export const setMockLoginAuth = (auth: string) => {
  localStorage.setItem('mockAuth', auth);
};

export const getMockLoginAuth = () => {
  const mockAuth = localStorage.getItem('mockAuth');
  return mockAuth === null ? false : mockAuth;
};

export const clearMockLoginAuth = () => {
  localStorage.removeItem('mockAuth');
};
